import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import {
  type ScheduledJobsParams,
  type UnscheduledJobsParams,
  getScheduledJobs,
  getUnscheduledJobs,
} from '../api/unscheduledJobsApi';

export function useUnscheduledJobs(params: UnscheduledJobsParams = {}) {
  return useQuery({
    queryKey: [...queryKeys.planner.all, 'unscheduled-jobs', params],
    queryFn: () => getUnscheduledJobs(params),
    staleTime: 10 * 1000,
  });
}

export function useScheduledJobs(params: ScheduledJobsParams = {}) {
  return useQuery({
    queryKey: [...queryKeys.planner.all, 'scheduled-jobs', params],
    queryFn: () => getScheduledJobs(params),
    staleTime: 10 * 1000,
  });
}
